import EnumField from 'components/Enum/EnumField';
import * as React from 'react';
import {
  TextField,
  Datagrid,
  FunctionField,
  SimpleShowLayout,
  ReferenceManyField,
  Pagination,
  NumberField,
  DateField,
  EditButton,
} from 'react-admin';
import LinkField from 'components/LinkField';
import MoneyField from 'components/MoneyField';
import {
  displayShiftTypes,
  displayWorkdays,
  displayLabels,
  displayPositions,
} from 'resources/professional_saas_details/utils';

const IrmTab = () => (
  <SimpleShowLayout>
    <ReferenceManyField
      pagination={<Pagination />}
      label=""
      reference="ProfessionalSaasDetail"
      target="professional_id"
    >
      <Datagrid bulkActionButtons={false}>
        <TextField label="ID" source="id" />
        <NumberField
          label="Max Weekly Hours"
          source="max_weekly_hours"
          options={{ maximumFractionDigits: 2 }}
        />
        <MoneyField label="Hourly Rate" source="hourly_rate_cents" />
        <FunctionField
          label="Shift Types"
          render={(record) => displayShiftTypes(record?.shift_types)}
        />
        <EnumField label="Employment Type" source="employment_type" />
        <DateField label="Offboarded At" source="offboarded_at" />
        <TextField label="Offboarded Reason" source="offboarded_reason" />
        <NumberField label="Preferred Weekly Total Shifts" source="preferred_weekly_total_shifts" />
        <FunctionField
          label="Preferred Workdays"
          render={(record) => displayWorkdays(record?.preferred_workdays)}
        />
        <FunctionField
          label="Preferred Job Slots"
          render={(record) => displayLabels(record?.preferred_job_slots)}
        />
        <FunctionField
          label="Preferred Positions"
          render={(record) => displayPositions(record?.preferred_positions)}
        />
        <FunctionField
          label="Preferred Locations"
          render={(record) => displayLabels(record?.preferred_locations)}
        />
        <DateField label="Preferences Last Updated At" source="preferences_last_updated_at" />
        <LinkField
          label="Preferences Updated By"
          source="preferences_last_updated_by_account_id"
          typename="Account"
        />
        <EditButton />
      </Datagrid>
    </ReferenceManyField>
  </SimpleShowLayout>
);

export default IrmTab;
